module.exports = __webpack_public_path__ + "img/product_mb_01.500b8a5.png";